import controller from './code-editor.controller';
import template from './code-editor.html';
import './code-editor.scss';

export default {
	template,
	bindings: {
		ngModel: '<',
		onEditorReady: '&',
		onSetup: '&',

		placeholder: '@?',
	},
	controller,
	controllerAs: '$ctrl',

	require: {
		ngModelCtrl: '?ngModel',
	},
};
